/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const RockingChair = [
  ["path", { d: "m15 13 3.708 7.416" }],
  ["path", { d: "M3 19a15 15 0 0 0 18 0" }],
  ["path", { d: "m3 2 3.21 9.633A2 2 0 0 0 8.109 13H18" }],
  ["path", { d: "m9 13-3.708 7.416" }]
];

export { RockingChair as default };
//# sourceMappingURL=rocking-chair.js.map
